//滚动热搜词
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
  function startmarquee(lh, speed, delay, wrapID) {
    this.lh = lh;
    this.speed = speed;
    this.delay = delay;
    this.wrapID = wrapID || 'hotword';
  }
  startmarquee.prototype.slide = function(){

    var p = false;
    var t;
    // var o = document.getElementById("toutiao-hotword");
    var o = document.getElementById(this.wrapID);
	if (o){
    o.innerHTML += o.innerHTML;
    o.style.marginTop = 0;
    o.onmouseover = function() {
        p = true;
    }
    o.onmouseout = function() {
        p = false;
    }
    function start() {
        t = setInterval(scrolling, this.speed);
        if (!p) o.style.marginTop = parseInt(o.style.marginTop) - 1 + "px";
    }

    function scrolling() {
        if (parseInt(o.style.marginTop) % this.lh != 0) {
            o.style.marginTop = parseInt(o.style.marginTop) - 1 + "px";
            if (Math.abs(parseInt(o.style.marginTop)) >= o.scrollHeight / 2) o.style.marginTop = 0;
        } else {
            clearInterval(t);
            setTimeout(start, this.delay);
        }
    }
    setTimeout(start, this.delay);
  }}
  return startmarquee;
}));



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/startmarquee.js
// module id = eb78b6bb2c0a70b96a87
// module chunks = 1